import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  deleteOpportunitytype,
  updateOpportunitytype,
} from "../graphQL/graphMutation";

export const updateOpportunityService = async (id, values) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateOpportunitytype, {
      id: id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.response?.errors?.[0]?.message, "updateOpportunityService-error");
  errormessage=err.response?.errors?.[0]?.message;
    updateStatus = false;
  }
  return {updateStatus ,errormessage};
};

export const deleteOpportunitytypeService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteOpportunitytype, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteOpportunitytypeService error");
    delteStatus = false;
  }

  return delteStatus;
};
